import React, { memo } from 'react';
import Lottie from 'react-lottie';

import animationData from './loadingAnimation.json';

import './index.less';

const lottieOptions = {
    animationData,
    loop: true,
    autoplay: true
};

const size = 48;
export interface LoadingProps {
    wrapperClassname?: string;
}

const Loading: React.FC<LoadingProps> = ({ wrapperClassname = '' }) => {
    return (
        <div className={`otps__components__pc__loading__wrapper ${wrapperClassname}`}>
            <Lottie
                options={lottieOptions}
                isClickToPauseDisabled={true}
                height={size}
                width={size}
            />
        </div>
    );
};

export default memo(Loading);
